var React = require('react');

function BlockAdsAndTrackersIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#2zuttwlcaa)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13 14v-4H4v22h40V10h-9v4h4v4H27v-4h4v-4H17v4h4v4H9v-4h4zm31-8h-9V0h-4v6H17V0h-4v6H0v30h48V6h-4zM26 42h18v-4H4v4h18v6h4v-6z","fill":"#8D6CFF"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"2zuttwlcaa"},React.createElement("path",{"fill":"#fff","d":"M0 0h48v48H0z"})))]);
}

BlockAdsAndTrackersIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = BlockAdsAndTrackersIcon;

BlockAdsAndTrackersIcon.default = BlockAdsAndTrackersIcon;
